import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
// pages
import Login from './pages/Login';
import DashboardApp from './pages/DashboardApp';
import Utentes from './pages/Utentes';
import Mensagens from './pages/Mensagens';
import Planos from './pages/Planos';
import PerfilUtente from './pages/PerfilUtente';
import PerfilPessoal from './pages/PerfilPessoal';
//import Definicoes from './pages/Definicoes';

import NotFound from './pages/Page404';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([

    { //page 404 -> pagina erro voltar ao inicio 
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { element: <Navigate to="/iniciar-sessao" replace /> },
        { path: 'iniciar-sessao', element: <Login /> },
        { path: '404', element: <NotFound /> },
        { path: '/', element: <Navigate to="/dashboard" /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },

    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard" replace /> },
        { path: 'dashboard', element: <DashboardApp /> },
        { path: 'utentes', element: <Utentes /> },
        { path: 'mensagens', element: <Mensagens /> },
        { path: 'planos', element: <Planos /> },
        { path: 'perfil', element: <PerfilPessoal /> },
      ]
    },
   
    {
      path: '/utentes',
      element: <DashboardLayout />,
      children: [
        { path: 'perfil', element: <PerfilUtente /> }
      ]
    },
    { path: '*', element: <Navigate to="/404" replace /> }
    
    /*
    {
      path: '/app',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/app/dashboard" replace /> },
        { path: 'dashboard', element: <DashboardApp /> },
        { path: 'utentes', element: <Utentes /> },
        { path: 'mensagens', element: <Mensagens /> },
        { path: 'planos', element: <Planos /> },
        { path: 'perfil', element: <PerfilPessoal /> },
      ]
    },

    { //page 404 -> pagina erro voltar ao inicio 
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: 'login', element: <Login /> },
        { path: '404', element: <NotFound /> },
        { path: '/', element: <Navigate to="/app" /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },

    {
      path: '/app/utentes',
      element: <DashboardLayout />,
      children: [
        { path: 'perfil', element: <PerfilUtente /> }
      ]
    },

    { path: '*', element: <Navigate to="/404" replace /> }
    */
  ]);
}
